import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent } from "@angular/common/http";
import { Observable, Subject } from 'rxjs'
import { tap, finalize } from 'rxjs/operators'
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { Provider } from '@angular/core';



@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log(req);
        if (req.headers.get('No-Auth') == "True"){
            return next.handle(req.clone());
        }
        //console.log("Interceptor");
        //console.log(localStorage.getItem('userToken'));

        if (localStorage.getItem('userToken') != null) {
            const clonedreq = req.clone({
                headers: req.headers.set("Authorization", "Bearer " + localStorage.getItem('userToken'))

            });
            return next.handle(clonedreq)
                .pipe(
                    tap(
                    event => { 
                       // console.log("event"); 
                    },
                    error => {
                        // console.log("DS SCout------AuthIntercepter:" + error.status);
                        // console.log("DS SCout------AuthIntercepter:" +error);
                        if (error.status === 401)
                            this.router.navigateByUrl('/login');
                        else if (error.status === 403)
                            this.router.navigateByUrl('/login');
                        else (error.status === 400  && (req.headers.get('forwarderror') == "True"))
                            return true;
                        //this.router.navigateByUrl('/forbidden');
                    }
                    ),
                     finalize(() => {
                       //console.log("interceptor finalize")
                      })
                );                
        }
        else {
            const clonedreq = req.clone();
            return next.handle(clonedreq);
        }
  }


    
}

// Injection token for the Http Interceptors multi-provider
import { HTTP_INTERCEPTORS } from '@angular/common/http';

/** Provider for the Noop Interceptor. */
export const authInterceptorProvider: Provider =
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true };